import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./ofertaDigital.js`).default;
const ofertaDigital = require(`./ofertaDigital.js`).default;

export default deepmerge(ofertaDigital, oferta);
